webpackJsonp([29,35],{

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(121),
	  /* template */
	  __webpack_require__(250),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keyboard = __webpack_require__(201);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'keyboarddemo',
	  components: {
	    Keyboard: _keyboard2.default
	  },
	  methods: {
	    handle: function handle(val) {
	      this.data = val;
	    }
	  },
	  data: function data() {
	    return {
	      data: '0'
	    };
	  }
	};

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    mode: {
	      type: String,
	      default: 'float' },
	    value: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value
	    };
	  },
	
	  watch: {
	    value: function value(newval) {
	      this.valueSelf = newval;
	    }
	  },
	  computed: {},
	  ready: function ready() {},
	  attached: function attached() {},
	
	  methods: {
	    handleClick: function handleClick(val) {
	      if (this.valueSelf === '0' || this.valueSelf === 0) {
	        this.valueSelf = '';
	      }
	
	      switch (val) {
	        case 'del':
	          {
	            this.valueSelf = this.valueSelf.substring(0, this.valueSelf.length - 1);
	            break;
	          }
	        case '.':
	          {
	            if (this.valueSelf.indexOf('.') === -1) {
	              this.valueSelf = this.valueSelf + val;
	            }
	            break;
	          }
	        default:
	          {
	            this.valueSelf = this.valueSelf + val;
	          }
	      }
	
	      this.$emit('on-click', this.valueSelf);
	      this.$emit('input', this.valueSelf);
	    }
	  },
	  components: {}
	};

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(122),
	  /* template */
	  __webpack_require__(245),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "keyboard bt"
	  }, [_c('div', {
	    staticClass: "bb ovf"
	  }, [_c('div', {
	    staticClass: "board-btn br"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(1)
	      }
	    }
	  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
	    staticClass: "board-btn br"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(2)
	      }
	    }
	  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
	    staticClass: "board-btn"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(3)
	      }
	    }
	  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
	    staticClass: "bb ovf"
	  }, [_c('div', {
	    staticClass: "board-btn br"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(4)
	      }
	    }
	  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
	    staticClass: "board-btn br"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(5)
	      }
	    }
	  }, [_vm._v("5")])]), _vm._v(" "), _c('div', {
	    staticClass: "board-btn"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(6)
	      }
	    }
	  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
	    staticClass: "bb ovf"
	  }, [_c('div', {
	    staticClass: "board-btn br"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(7)
	      }
	    }
	  }, [_vm._v("7")])]), _vm._v(" "), _c('div', {
	    staticClass: "board-btn br"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(8)
	      }
	    }
	  }, [_vm._v("8")])]), _vm._v(" "), _c('div', {
	    staticClass: "board-btn"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(9)
	      }
	    }
	  }, [_vm._v("9")])])]), _vm._v(" "), _c('div', {
	    staticClass: "bb ovf"
	  }, [_c('div', {
	    staticClass: "board-btn br"
	  }, [(_vm.mode == 'int') ? _c('button', {
	    staticClass: "none",
	    attrs: {
	      "type": "button"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.mode == 'float') ? _c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick('.')
	      }
	    }
	  }, [_vm._v("\n        .\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "board-btn br"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick(0)
	      }
	    }
	  }, [_vm._v("0")])]), _vm._v(" "), _c('div', {
	    staticClass: "board-btn"
	  }, [_c('button', {
	    staticClass: "del",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleClick('del')
	      }
	    }
	  }, [_vm._v("Del")])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('div', {
	    staticClass: "p2222 card card-square"
	  }, [_vm._v("\n    " + _vm._s(_vm.data) + "\n  ")]), _vm._v(" "), _c('keyboard', {
	    model: {
	      value: (_vm.data),
	      callback: function($$v) {
	        _vm.data = $$v
	      },
	      expression: "data"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.dde933c6403d9db06479.js